import styled from 'styled-components'
import { CRIMSON_500, DARK_VIOLET, NEUTRAL_100, PALE_BLUE, WHITE } from '@styles/colors'
import { INTER } from '@styles/fonts'
import { safeAreaInset } from '@lib/telegram'

// Main container
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  overflow: hidden;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: space-between;
  overflow-y: auto;
`

export const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 12px 50vh 12px;
  overflow-y: auto;
`

// Bank Information Card components
export const BankCardContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background-color: ${PALE_BLUE};
  border-radius: 8px;
  border: 1px solid ${NEUTRAL_100};
`

export const BankIconWrapper = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 100%;
  overflow: hidden;
`

export const BankIcon = styled.img`
  width: 36px;
  height: 36px;
  aspect-ratio: 1/1;
  object-fit: cover;
`

export const BankName = styled.span`
  font-family: ${INTER.medium};
  color: ${DARK_VIOLET};
`

// Amount Display components
export const AmountDisplayContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const AmountText = styled.span`
  font-family: ${INTER.bold};
  color: ${DARK_VIOLET};
  font-size: 1.75rem;
`

export const AmountWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 28px;
  margin-bottom: 0px;
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${NEUTRAL_100};
  margin: 16px 0;
`

// Quick Amount Buttons components
export const QuickAmountContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
`

export const QuickAmountButton = styled.div`
  display: flex;
  padding: 6px 12px;
  border-radius: 18px;
  border: 1px solid ${NEUTRAL_100};
  align-items: center;
  justify-content: center;
  cursor: pointer;
`

export const QuickAmountText = styled.span`
  font-family: ${INTER.medium};
  color: ${DARK_VIOLET};
`

// Bottom section components
export const ErrorMessageContainer = styled.div`
  color: ${CRIMSON_500};
  margin-bottom: 16px;
  font-family: ${INTER.regular};
  font-size: 12px;
  width: 100%;
  text-align: center;
`

export const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 32px;
  padding: 16px 12px 24px 12px;
  padding-bottom: ${safeAreaInset().bottom || 24}px;
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: ${WHITE};
`
